<template>
    <div class="c-info" :class="{error:error,'hover-box':hover}">
        <div class="hover">
            <div class="hover-left text-hidden-mul">{{name}}</div>
            <div class="hover-right">
                <span class="btn-blue" @click="$emit('edit')" style="margin-left:0.1rem;">编辑</span>
                <span class="btn-blue" @click="$emit('delete')" style="margin-left:0.1rem;">删除</span>
            </div>
        </div>
        <!-- native -->
        <div v-if="type=='Native'" class="native">
            <div class="header">
                <img :src="icon" />
                <span class="title showregular">{{title}}</span>
            </div>
            <div class="body">
                <img :src="img" />
            </div>
            <div class="footer">
                <div class="normal">
                    <div class="desc text-hidden-mul" style="-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{desc}}</div>
                    <Button class="button-text" type="info" size="small">{{buttonText}}</Button>
                </div>
            </div>
        </div>

        <!-- Banner -->
        <div v-if="type=='Banner'" class="banner">
            <img class="iconImg" :src="icon">
            <div class="text showregular">
                <p class="title showregular">{{title}}</p>
                <!-- <p class="desc showregular">{{desc}}</p> -->
            </div>
            <span class="button-text">{{buttonText}}</span>
        </div>

        <!-- Interstitial -->
        <div v-if="type=='Interstitial'" class="interstitial">
            <img class="img" :src="img" />
            <img class="iconImg" :src="icon" />
            <div class="title">{{title}}</div>
            <div class="desc" style="-webkit-line-clamp: 2;-webkit-box-orient:vertical">{{desc}}</div>
            <div class="button-text" type="info">{{buttonText}}</div>
        </div>

        <!-- mrec -->
        <div v-if="type=='Mrec'" class="mrec">
            <img class="img" :src="img" />
            <div class="body">
                <img class="iconImg" :src="icon" />
                <div class="body-right">
                    <p class="title showregular">{{title}}</p>
                    <p class="desc text-hidden-mul" style="-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{desc}}</p>
                </div>
            </div> 
            <div class="button-text" type="info">{{buttonText}}</div>
        </div>

    </div>
</template>
<script>
/**
 * @desc 通用信息流预览模板
 * @prop {String} type 模板类型：Banner,Mrec,Interstitial,Native
 * @prop {Boolean} hover 是否启用hover显示复制，删除功能
 * @prop {String} icon 图标
 * @prop {String} img 主图
 * @prop {String} title 标题
 * @prop {String} desc 描述
 * @prop {String} buttonText 按钮文案
 * @prop {String} name 图片名称
 */
export default {
    name: 'cInfo',
    props: {
        type: {
            type: String,
            default: 'Native',
        },
        hover: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: 'http://cdn.batmobi.net/appstore/richmedia/20180904/d0e983068061484291237865349a6a12.jpg',
        },
        img: {
            type: String,
            default: 'http://cdn.batmobi.net/appstore/richmedia/20180904/086596b6ffa94173a20c78709f612773.jpg',
        },
        title: {
            type: String,
            default: '标题',
        },
        desc: {
            type: String,
            default: '描述',
        },
        buttonText: {
            type: String,
            default: 'Install',
        },
        name: {
            type: String,
            default: '',
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss">
.c-info {
    position: relative;
    overflow: hidden;
    box-shadow: 0px 0px 10px 3px rgba(233, 233, 233, 1);
    box-sizing: border-box;
    overflow: hidden;
    font-family: PingFangSC-Semibold;
    width: auto;
    .desc {
        color: #a0a0a0;
        background: #f5f5f9;
    }
    &.hover-box {
        &:hover {
            .hover {
                display: flex;
                bottom: 0;
            }
        }
    }
    .hover {
        z-index: 1000;
        position: absolute;
        width: 100%;
        padding: 0.05rem;
        display: none;
        justify-content: space-between;
        align-items: center;
        height: 0.42rem;
        overflow: hidden;
        background: #eaeaee;
        bottom: -100%;
        left: 0;
        .hover-right {
            flex: 0 0 auto;
        }
    }
    .native {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: #f5f5f9;
        position: relative;
        width: 3.2rem;
        &.error {
            box-shadow: 0px 0px 4px 1px rgba(255, 48, 48, 1);
        }
        .header {
            padding: 0.05rem;
            display: flex;
            & > img {
                flex: 0 0 auto;
                width: 0.378rem;
                height: 0.378rem;
                margin-right: 0.1rem;
            }
            .title {
                flex: 1 1 auto;
                line-height: 0.378rem;
                font-size: 0.16rem;
            }
        }
        .footer {
            width: 100%;
            position: relative;
            height: 0.42rem;
            .normal {
                width: 100%;
                padding: 0.05rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 0.42rem;
                overflow: hidden;
                .desc {
                    margin-right: 0.05rem;
                    line-height: 0.16rem;
                    height: 0.32rem;
                    flex: 1 1 auto;
                }
                .button-text {
                    flex: 0 0 auto;
                    height: 0.26rem;
                    border-radius: 13px;
                }
            }
        }
    }
    .banner {
        width: 3.2rem;
        height: 0.5rem;
        background: #ffffff;
        display: flex;
        padding: 0 0.05rem;
        align-items: center;
        .iconImg {
            flex: 0 0 auto;
            height: 0.38rem;
            width: 0.38rem;
            border-radius: 5px;
            margin-right: 0.15rem;
        }
        .text {
            flex: 1 1 auto;
            margin-right: 0.05rem;
            height: 0.5rem;
            .title {
                line-height: 0.5rem;
                font-size: 0.14rem;
            }
            .desc {
                line-height: 0.18rem;
                font-size: 0.12rem;
            }
        }
        .button-text {
            flex: 0 0 auto;
            border-radius: 16px;
            width: 0.9rem;
            line-height: 0.3rem;
            height: 0.3rem;
            font-size: 0.13rem;
            background-color: #27c5af;
            text-align: center;
            color: #fff;
        }
    }
    .interstitial {
        width: 3.2rem;
        height: 4.8rem;
        .img {
            width: 3.2rem;
            height: 1.68rem;
            display: block;
        }

        .iconImg {
            width: 0.74rem;
            height: 0.74rem;
            margin: 0.3rem auto;
            display: block;
            border-radius: 8px;
        }

        .title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 0.26rem;
            line-height: 0.34rem;
            text-align: center;
            margin: 0 0.2rem;
        }

        .desc {
            margin: 0 0.2rem;
            margin-top: 0.1rem;
            font-size: 0.18rem;
            line-height: 0.26rem;
            height: 0.52rem;
            color: #545454;
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            text-align: center;
            background: none;
        }

        .button-text {
            border-radius: 0.25rem;
            color: #fff;
            width: 2.78rem;
            margin: 0 auto;
            margin-top: 0.12rem;
            text-align: center;
            height: 0.4rem;
            line-height: 0.4rem;
            font-size: 0.18rem;
            background-color: #27c5af;
            border-radius: 0.2rem;
        }
    }
    .mrec {
        position: relative;
        width: 3rem;
        height: 2.5rem;
        .img {
            width: 3rem;
            height: 1.88rem;
        }
        .body {
            position: absolute;
            bottom: 0;
            width: 3rem;
            height: 1.28rem;
            background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 1));
            padding: 0.09rem 0;
            display: flex;
            box-sizing: border-box;
            .iconImg {
                flex: 0 0 0.62rem;
                width: 0.62rem;
                height: 0.62rem;
                margin: 0 0.2rem;
                border-radius: 8px;
            }
            .body-right {
                flex: 1 1 auto;
                overflow: hidden;
            }
            .title {
                width: 1.8rem;
                font-size: 0.18rem;
                line-height: 0.32rem;
            }
            .desc {
                width: 1.8rem;
                background: none;
                line-height: 0.14rem;
                height: 0.28rem;
                font-size: 0.12rem;
            }
        }
        .button-text {
            position: absolute;
            bottom: 0.09rem;
            left: 0.2rem;
            width: 2.6rem;
            border-radius: 0.18rem;
            height: 0.36rem;
            line-height: 0.36rem;
            font-size: 0.18rem;
            background-color: #27c5af;
            text-align: center;
            color: #fff;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/commons/cInfo.vue